/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ModelVoucher } from 'account-client'
import { HoverTips } from '@/components/HoverTips'
import { StateTag } from '@/components/StateTag'
import { useTranslateAmount } from '@/hooks/useTranslateAmount'
import { timeFormatter } from '@/utils/timeFormatter'

export function useVouchersColumns() {
  const { t } = useTranslation()
  const { currency } = useTranslateAmount()

  const columns = useMemo<TableColumnsType<ModelVoucher>>(
    () => [
      {
        title: t('Voucher ID'),
        dataIndex: 'id',
      },
      {
        title: t('State'),
        dataIndex: 'state',
        render: value => <StateTag state={value} />,
      },
      {
        title: `${t('Voucher Denomination')}（${currency}）`,
        dataIndex: 'denominationFormatted',
      },
      {
        title: `${t('Voucher Balance')}（${currency}）`,
        dataIndex: 'balanceFormatted',
      },
      {
        title: <HoverTips title={t('vouchers_valid_start_desc')}>{t('Valid Start on')}</HoverTips>,
        dataIndex: 'start',
        render: value => timeFormatter.format(value),
      },
      {
        title: <HoverTips title={t('vouchers_depleted_end_start_desc')}>{t('Depleted on')}</HoverTips>,
        dataIndex: 'end',
        render: value => timeFormatter.format(value),
      },
      {
        title: t('Distributed on'),
        dataIndex: 'gmtCreated',
        sorter: true,
        // width: 160,
        render: date => timeFormatter.format(date),
      },
      // {
      //   title: t('Description'),
      //   dataIndex: 'description',
      //   render: value => <span className="description-text">{value}</span>,
      // },
    ],
    [],
  )

  return columns
}
